@if (mostraStatus()) {
  <app-status-mensagem class="previa-status" [status]="previa?.status"></app-status-mensagem>
}
@if (icone(); as icone) {
  <img class="previa-icone" [src]="icone" alt="" />
}
<span class="previa-texto" [innerHTML]="texto()"></span>
